import GlobalConstant from '@/constants/GlobalConstant';

export default class CommonValidate {
  /**
   * 验证数据必须是数字和字母
   * @param rule
   * @param value
   * @param callback
   */
  static validateNumAndLetter = (rule: any, value: any, callback: any) => {
    if (!GlobalConstant.RegExpNumberAndLetter.test(value)) {
      callback(new Error('必须是数字、字母'));
    } else {
      callback();
    }
  };

  /**
   * 验证手机号码必须是数字,长度是6-11
   * @param rule
   * @param value
   * @param callback
   */
  static validatePhone = (rule: any, value: any, callback: any) => {
    if (!value || value.trim().length === 0) {
      callback(new Error('手机号码不能为空'));
    } else if (!GlobalConstant.RegExpPhoneNo.test(value)) {
      callback(new Error('手机号码必须是数字,长度是6-11位'));
    } else {
      callback();
    }
  };

  /**
   * 验证用户名称不能为空,要去掉首位的空白字符
   * @param rule
   * @param value
   * @param callback
   */
  static validateUserName = (rule:any, value:any, callback:any) => {
    if (!value || value.trim().length === 0) {
      callback(new Error('用户名不能为空'));
    } else {
      callback();
    }
  };

  /**
   * 验证客户名称不能为空,要去掉首位的空白字符
   * @param rule
   * @param value
   * @param callback
   */
   static validateCustomerName = (rule:any, value:any, callback:any) => {
     if (!value || value.trim().length === 0) {
       callback(new Error('客户名不能为空'));
     } else {
       callback();
     }
   };

   /**
   * 验证角色名称不能为空,要去掉首位的空白字符
   * @param rule
   * @param value
   * @param callback
   */
   static validateRoleName = (rule:any, value:any, callback:any) => {
     if (!value || value.trim().length === 0) {
       callback(new Error('角色名不能为空'));
     } else {
       callback();
     }
   };

   /**
   * 验证账号昵称不能为空,要去掉首位的空白字符
   * @param rule
   * @param value
   * @param callback
   */
   static validateNickName = (rule:any, value:any, callback:any) => {
     if (!value || value.trim().length === 0) {
       callback(new Error('账号昵称不能为空'));
     } else {
       callback();
     }
   };

   /**
   * 验证账号名,必须是字母和数字,长度5-10位
   * @param rule
   * @param value
   * @param callback
   */
   static validateAccount = (rule:any, value:any, callback:any) => {
     if (!/^[A-Za-z0-9]{5,10}$/.test(value)) {
       callback(new Error('账号名必须是字母和数字,长度是5-10位'));
     } else {
       callback();
     }
   };

   /**
    * 验证用户编码
    * @param rule
    * @param value
    * @param callback
    */
   static validateCode = (rule:any, value:any, callback:any) => {
     if (!/^[A-Za-z0-9]{1,6}$/.test(value)) {
       callback(new Error('用户编码必须是数字或字母,长度是1-6位'));
     } else {
       callback();
     }
   };

   /**
   * 验证密码
   * @param rule
   * @param value
   * @param callback
   */
   static validatePass = (rule:any, value:any, callback:any) => {
     if (!/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,15}$/.test(value)) {
       callback(new Error('密码必须包含数字和字母且长度6至15'));
     } else {
       callback();
     }
   };

   /**
   * 验证描述不能为空,要去掉首位的空白字符
   * @param rule
   * @param value
   * @param callback
   */
   static validateDesc = (rule:any, value:any, callback:any) => {
     if (!value || value.trim().length === 0) {
       callback(new Error('描述不能为空'));
     } else {
       callback();
     }
   };
}
